export default __webpack_public_path__ + "static/media/doctor4.62dc1e67.jpg";